export default __webpack_public_path__ + "static/media/Logotype-Stacked-Reversed.8d0660cb.svg";